
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/ultimate-guide-to-8-airbnb-experiences-for-foodies",
      function () {
        return require("private-next-pages/blog/ultimate-guide-to-8-airbnb-experiences-for-foodies.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/ultimate-guide-to-8-airbnb-experiences-for-foodies"])
      });
    }
  